<template>
    <b-dropdown
            right
            class="property-saved-searches-save-button text-center"
            menu-class="p-0 w-100"
            toggle-class="text-truncate d-flex align-items-center align-content-center shadow-none justify-content-center"
            no-caret
            ref="saveSearchDropdown"
            v-if="!filter.isSold"
    >
        <template v-slot:button-content>
            <h3 class="mb-0 font-weight-bold text-truncate">
                <i
                        :class="[isSubmitted ? 'fa-check' : 'fa-bell']"
                        class="far mr-2"
                />
                {{ isSubmitted ? 'Search Saved' : 'Save Search' }}
            </h3>
        </template>
        <b-card
                header="NAME"
                header-tag="h4"
                class="border-0 rounded-0"
                body-class="p-3"
        >
            <b-form @submit.prevent="handleSubmit">
                <b-input
                        v-model="filterName"
                        placeholder="Name Your Search"
                />

                <b-form-checkbox
                    name="checkbox-subscribe"
                    class="my-4"
                    :value="currentProjectMember"
                    v-model="subProjectMembers"
                >
                    Notify me when new homes match my criteria
                </b-form-checkbox>

                <div
                    v-if="users.length"
                    class="d-flex align-items-center font-size-sm text-gray-800 my-4"
                    @click.stop="displayShareModal"
                >
                    Shared with
                    <storage-avatar-nested
                        class="ml-2"
                        :users="users"
                    />
                </div>

                <b-button
                        variant="primary"
                        type="submit"
                        size="lg"
                        class="mt-3"
                        block
                >
                    Save
                </b-button>
                <b-button
                    v-if="!users.length"
                    block
                    variant="transparent"
                    size="lg"
                    type="button"
                    class="text-primary"
                    @click.stop="displayShareModal"
                >
                    Share with Member
                </b-button>
            </b-form>
        </b-card>
    </b-dropdown>
</template>

<script>
    import './PropertySavedSearchesSaveButton.scss';
    import PropertySearchFilterRepository from "../../../../fixtures/PropertySearchFilterRepository";
    import ShowNotificationMixin from '@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin';
    import {proxyFilter} from "../../../classes/Filter";
    import {store} from "../../../../index";
    import {AppResourceCollection} from "@milestoneslabs/milestones-js-engine";
    import {PROPERTY_SAVED_SEARCHES_SHARE_MODAL_DISPLAY}
        from "../PropertySavedSearchesShareModal/PropertySavedSearchesShareModal";
    import SavedSearchAlertsMixin from "../../../mixins/SavedSearchAlertsMixin";

    import StorageAvatarNested from "../../StorageImage/StorageAvatarNested";
    import {buildFilterDataObjectFromFilter} from "../../../../helpers/functions";
    import {PROPERTY_SEARCH_ACTIONS} from "../../../../helpers/variables";

    export const PROPERTY_SEARCH_FILTERS_CHANGED = 'PropertySearchHeader:filters-changed';

    export default {
        name: "PropertySavedSearchesSaveButton",

        components: {
            StorageAvatarNested,
        },

        mixins: [
            ShowNotificationMixin,
            SavedSearchAlertsMixin,
        ],

        data() {
            return {
                filter: proxyFilter,
                isSubmitted: false,
                filterName: '',
                projectUuid: store.getters.getWorkspaceUuid,
                subProjectMembers: [],
                event: Math.random().toString(36).substr(2, 9),
            };
        },

        computed: {
            users() {
                const users = [];
                for (let projectMember of this.subProjectMembers) {
                    if (projectMember.uuid !== this.currentProjectMember.uuid) {
                        users.push(projectMember.user);
                    }
                }
                return users;
            },
        },

        beforeMount() {
            this.$bus.$on(PROPERTY_SEARCH_FILTERS_CHANGED, this.handleFilterChangeEvent);
            this.$bus.$on(this.event, this.handleShareEvent);
        },

        beforeDestroy() {
            this.$bus.$off(PROPERTY_SEARCH_FILTERS_CHANGED, this.handleFilterChangeEvent);
            this.$bus.$off(this.event, this.handleShareEvent);
        },

        mounted() {
            if (
                this.$route.query.propertySearchAction &&
                this.$route.query.propertySearchAction === PROPERTY_SEARCH_ACTIONS.SAVE_SEARCH
            ) {
                this.$refs.saveSearchDropdown.show();
            }
            this.subProjectMembers.push(this.currentProjectMember);
        },

        methods: {
            async handleSubmit() {
                let data = buildFilterDataObjectFromFilter(this.filter);
                let propertySearchFilterRepository = new PropertySearchFilterRepository();
                propertySearchFilterRepository.setAttribute('name', this.filterName)
                    .setAttribute('data', data)
                    .setAttribute('projectUuid', this.projectUuid)
                    .setAttribute('projectOrganizationMemberUuid', this.currentProjectMember.uuid);
                try {
                    let self = this;
                    await this.updateSubscribers(propertySearchFilterRepository, this.subProjectMembers);
                    propertySearchFilterRepository.once('created', () => {
                        this.showNotification({
                            message: 'Search saved!',
                            type: 'success'
                        });
                        this.filterName = '';
                        this.subProjectMembers = [];
                        this.$refs.saveSearchDropdown.hide(true);
                    });
                } catch (e) {
                    this.showNotification({
                        message: 'Something went wrong. Please try again later',
                        type: 'error'
                    });
                    console.error(e);
                    this.isSubmitted = false;
                }
            },

            handleFilterChangeEvent() {
                this.isSubmitted = false;
            },

            displayShareModal() {
                let collection = new AppResourceCollection('workspace-organization-Member');
                this.$bus.$emit(
                    PROPERTY_SAVED_SEARCHES_SHARE_MODAL_DISPLAY,
                    {
                        entity: collection,
                        event: this.event,
                        emitClosed: true,
                    }
                );
            },

            handleShareEvent(projectMembers) {
                if (!Array.isArray(projectMembers)) {
                    throw new Error('Invalid payload, projectMembers should be an array.');
                }
                this.subProjectMembers = this.subProjectMembers.concat(projectMembers);
                this.$refs.saveSearchDropdown.show(true);
            }
        }
    };
</script>
